import { render, staticRenderFns } from "./privacy_en.vue?vue&type=template&id=a72bf5b0"
import script from "./privacy_en.vue?vue&type=script&lang=js"
export * from "./privacy_en.vue?vue&type=script&lang=js"
import style0 from "./privacy_en.vue?vue&type=style&index=0&id=a72bf5b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports